function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Limitless imports
// import { isEmailValid } from "@limitless/customer/utils";
import { isFieldEmpty } from "@limitless/common/utils";
import CheckRadioField from "./CheckRadioField";
const RadioTextField = ({
  check,
  onChange,
  ...rest
}) => {
  const {
    isInvalid = false
  } = check;
  const validateRadioAndUpdate = newValue => {
    let isInvalid = false;
    if (isFieldEmpty(newValue)) {
      isInvalid = true;
    }
    onChange(newValue, isInvalid);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CheckRadioField, _extends({}, rest, {
    check: check,
    options: check.render.items,
    onChange: validateRadioAndUpdate,
    helperText: isInvalid ? "Please select one option" : null
  })));
};
export default RadioTextField;
RadioTextField.propTypes = {
  check: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};